var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "crm-tasks-page"
  }, [_c('section', {
    staticClass: "crm-tasks-panel"
  }, [_c('header', {
    staticClass: "crm-tasks-header"
  }, [_c('div', [_c('h1', [_vm._v("Tarefas")]), _c('span', [_vm._v(_vm._s(_vm.pagination.total) + " registros encontrados")])]), _c('button', {
    staticClass: "btn btn-dark font-weight-bolder font-size-sm",
    on: {
      "click": _vm.abrirModal
    }
  }, [_vm._v(" Nova tarefa ")])]), _c('div', {
    staticClass: "crm-tasks-filters"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Buscar por tarefa, oportunidade ou contato"
    },
    on: {
      "input": _vm.debouncedLoadAtividades
    },
    model: {
      value: _vm.filtros.busca,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "busca", $$v);
      },
      expression: "filtros.busca"
    }
  }), _c('b-form-select', {
    attrs: {
      "options": _vm.statusFilterOptions
    },
    on: {
      "change": _vm.trocarFiltroStatus
    },
    model: {
      value: _vm.filtros.status,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "status", $$v);
      },
      expression: "filtros.status"
    }
  }), _c('button', {
    staticClass: "btn btn-light btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.loadAtividades
    }
  }, [_vm._v(" Atualizar ")])], 1), _c('div', {
    staticClass: "crm-tasks-table-wrap"
  }, [_c('table', {
    staticClass: "crm-tasks-table"
  }, [_vm._m(0), _c('tbody', [_vm.loading ? _c('tr', [_c('td', {
    staticClass: "crm-tasks-empty",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Carregando tarefas...")])]) : !_vm.tarefas.length ? _c('tr', [_c('td', {
    staticClass: "crm-tasks-empty",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(" Nenhuma tarefa encontrada ")])]) : _vm._l(_vm.tarefas, function (tarefa) {
    return _c('tr', {
      key: tarefa.id_crm_atividade,
      staticClass: "crm-task-row",
      class: {
        'is-late': _vm.isLate(tarefa)
      },
      on: {
        "click": function click($event) {
          return _vm.abrirDrawer(tarefa);
        }
      }
    }, [_c('td', [_c('div', {
      staticClass: "crm-task-title-cell"
    }, [_c('i', {
      staticClass: "la la-check-square"
    }), _c('div', [_c('strong', [_vm._v(_vm._s(tarefa.titulo))]), _c('span', [_vm._v(_vm._s(_vm.tipoTexto(tarefa.tipo)))])])])]), _c('td', [_c('span', {
      staticClass: "crm-task-status",
      class: _vm.statusClass(tarefa)
    }, [_vm._v(" " + _vm._s(_vm.statusTexto(tarefa)) + " ")])]), _c('td', [_vm._v(_vm._s(_vm.formatDateTime(tarefa.vencimento_em)))]), _c('td', [_vm._v(_vm._s(tarefa.usuario || "Sem responsável"))]), _c('td', [tarefa.id_crm_oportunidade ? _c('button', {
      staticClass: "crm-task-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.abrirOportunidade(tarefa);
        }
      }
    }, [_vm._v(" " + _vm._s(tarefa.oportunidade || "Abrir oportunidade") + " ")]) : _c('span', [_vm._v(_vm._s(tarefa.contato || "Sem oportunidade"))])])]);
  })], 2)])]), _c('footer', {
    staticClass: "crm-tasks-footer"
  }, [_c('b-form-select', {
    staticClass: "crm-tasks-per-page",
    attrs: {
      "options": _vm.perPageOptions
    },
    on: {
      "change": _vm.trocarPorPagina
    },
    model: {
      value: _vm.pagination.perPage,
      callback: function callback($$v) {
        _vm.$set(_vm.pagination, "perPage", $$v);
      },
      expression: "pagination.perPage"
    }
  }), _c('div', {
    staticClass: "crm-tasks-pages"
  }, [_c('button', {
    staticClass: "btn btn-light btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.loading || _vm.pagination.page <= 1
    },
    on: {
      "click": function click($event) {
        return _vm.trocarPagina(_vm.pagination.page - 1);
      }
    }
  }, [_vm._v(" Voltar ")]), _c('span', [_vm._v("Página " + _vm._s(_vm.pagination.page) + " de " + _vm._s(_vm.lastPage))]), _c('button', {
    staticClass: "btn btn-light btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.loading || _vm.pagination.page >= _vm.lastPage
    },
    on: {
      "click": function click($event) {
        return _vm.trocarPagina(_vm.pagination.page + 1);
      }
    }
  }, [_vm._v(" Próximo ")])])], 1)]), _c('b-sidebar', {
    attrs: {
      "backdrop": "",
      "right": "",
      "shadow": "",
      "title": "Detalhes da tarefa",
      "width": "460px"
    },
    model: {
      value: _vm.drawerVisible,
      callback: function callback($$v) {
        _vm.drawerVisible = $$v;
      },
      expression: "drawerVisible"
    }
  }, [_vm.tarefaSelecionada ? _c('div', {
    staticClass: "crm-task-drawer"
  }, [_c('div', {
    staticClass: "crm-task-drawer-top"
  }, [_c('span', {
    staticClass: "crm-task-status",
    class: _vm.statusClass(_vm.tarefaSelecionada)
  }, [_vm._v(" " + _vm._s(_vm.statusTexto(_vm.tarefaSelecionada)) + " ")]), _c('div', {
    staticClass: "crm-task-drawer-actions"
  }, [_vm.canEditTarefa(_vm.tarefaSelecionada) && !_vm.drawerEditando ? _c('button', {
    staticClass: "btn btn-light btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.iniciarEdicaoDrawer
    }
  }, [_vm._v(" Editar ")]) : _vm._e(), _vm.drawerEditando ? _c('button', {
    staticClass: "btn btn-light btn-sm",
    attrs: {
      "type": "button",
      "disabled": _vm.loadingDrawerSave
    },
    on: {
      "click": _vm.cancelarEdicaoDrawer
    }
  }, [_vm._v(" Cancelar ")]) : _vm._e()])]), _vm.drawerEditando ? [_c('b-form-group', {
    attrs: {
      "label": "Título"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.drawerForm.titulo,
      callback: function callback($$v) {
        _vm.$set(_vm.drawerForm, "titulo", $$v);
      },
      expression: "drawerForm.titulo"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Tipo"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.tipos
    },
    model: {
      value: _vm.drawerForm.tipo,
      callback: function callback($$v) {
        _vm.$set(_vm.drawerForm, "tipo", $$v);
      },
      expression: "drawerForm.tipo"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Responsável"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.usuarioOptionsSemTodos
    },
    model: {
      value: _vm.drawerForm.id_usuario,
      callback: function callback($$v) {
        _vm.$set(_vm.drawerForm, "id_usuario", $$v);
      },
      expression: "drawerForm.id_usuario"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Data e hora"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "datetime-local"
    },
    model: {
      value: _vm.drawerForm.vencimento_em,
      callback: function callback($$v) {
        _vm.$set(_vm.drawerForm, "vencimento_em", $$v);
      },
      expression: "drawerForm.vencimento_em"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Descrição"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "4"
    },
    model: {
      value: _vm.drawerForm.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.drawerForm, "descricao", $$v);
      },
      expression: "drawerForm.descricao"
    }
  })], 1), _c('button', {
    staticClass: "btn btn-dark btn-block",
    attrs: {
      "type": "button",
      "disabled": _vm.loadingDrawerSave
    },
    on: {
      "click": _vm.salvarEdicaoDrawer
    }
  }, [_vm._v(" Salvar alterações ")])] : [_c('h2', [_vm._v(_vm._s(_vm.tarefaSelecionada.titulo))]), _c('dl', [_c('div', [_c('dt', [_vm._v("Tipo")]), _c('dd', [_vm._v(_vm._s(_vm.tipoTexto(_vm.tarefaSelecionada.tipo)))])]), _c('div', [_c('dt', [_vm._v("Data e hora")]), _c('dd', [_vm._v(_vm._s(_vm.formatDateTime(_vm.tarefaSelecionada.vencimento_em)))])]), _c('div', [_c('dt', [_vm._v("Responsável")]), _c('dd', [_vm._v(_vm._s(_vm.tarefaSelecionada.usuario || "Sem responsável"))])]), _c('div', [_c('dt', [_vm._v("Negociação")]), _c('dd', [_vm._v(" " + _vm._s(_vm.tarefaSelecionada.oportunidade || "Sem oportunidade vinculada") + " ")])]), _c('div', [_c('dt', [_vm._v("Contato")]), _c('dd', [_vm._v(" " + _vm._s(_vm.tarefaSelecionada.contato || "Sem contato vinculado") + " ")])]), _vm.tarefaSelecionada.concluido_em ? _c('div', [_c('dt', [_vm._v("Conclusão")]), _c('dd', [_vm._v(_vm._s(_vm.formatDateTime(_vm.tarefaSelecionada.concluido_em)))])]) : _vm._e()]), _c('section', {
    staticClass: "crm-task-description"
  }, [_c('strong', [_vm._v("Descrição")]), _c('p', [_vm._v(_vm._s(_vm.tarefaSelecionada.descricao || "Sem descrição."))])])], _vm.tarefaSelecionada.id_crm_oportunidade && !_vm.drawerEditando ? _c('button', {
    staticClass: "btn btn-dark btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.abrirOportunidade(_vm.tarefaSelecionada);
      }
    }
  }, [_vm._v(" Abrir oportunidade ")]) : _vm._e(), _vm.canEditTarefa(_vm.tarefaSelecionada) && !_vm.drawerEditando ? _c('button', {
    staticClass: "btn btn-success btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.concluirTarefa(_vm.tarefaSelecionada);
      }
    }
  }, [_vm._v(" Concluir tarefa ")]) : _vm._e()], 2) : _vm._e()]), _c('b-modal', {
    attrs: {
      "id": "crm-tarefa-modal",
      "title": "Nova tarefa",
      "ok-title": "Salvar",
      "cancel-title": "Cancelar"
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.salvar.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Título"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.form.titulo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "titulo", $$v);
      },
      expression: "form.titulo"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Tipo"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.tipos
    },
    model: {
      value: _vm.form.tipo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tipo", $$v);
      },
      expression: "form.tipo"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Vencimento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "datetime-local"
    },
    model: {
      value: _vm.form.vencimento_em,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "vencimento_em", $$v);
      },
      expression: "form.vencimento_em"
    }
  })], 1), _c('BuscaClienteContato', {
    attrs: {
      "label": "Contato ou oportunidade",
      "incluir-pessoas": false,
      "incluir-oportunidades": ""
    },
    on: {
      "criar-contato": _vm.criarContatoRapido
    },
    model: {
      value: _vm.vinculoSelecionado,
      callback: function callback($$v) {
        _vm.vinculoSelecionado = $$v;
      },
      expression: "vinculoSelecionado"
    }
  }), _c('b-form-group', {
    attrs: {
      "label": "Descrição"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "3"
    },
    model: {
      value: _vm.form.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "descricao", $$v);
      },
      expression: "form.descricao"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Tarefa")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Data e hora")]), _c('th', [_vm._v("Responsável")]), _c('th', [_vm._v("Negociação")])])]);
}];
export { render, staticRenderFns };